import { Component, OnInit, AfterViewInit  } from '@angular/core';
import * as $ from 'jquery';
//import * as MyModule from './assets/plugins/matchheight/matchHeight.js';
declare function matchHeight(): any;

@Component({
  selector: 'app-smme',
  templateUrl: './smme.component.html',

})
/** smme component*/
export class SmmeComponent implements OnInit, AfterViewInit   {
  /** smme ctor */
  constructor() {
    console.log("smme constructor");
  }

  ngOnInit() { }

  ngAfterViewInit() {
    

    $(function () {
      console.log("jquery ready");
      //$("#tstHeight").css("height", "100%");
      try {
        //$(".match-height").matchHeight();
      } catch (e) {
        console.log(e.message);
      }
    });
    
  }

 
}
